import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { ENUM_DELIVERY_MODEL_LABELS } from '@/_features/dashboard/constants';

interface DeliveryModelInitialState {
  selectedsDeliveryModel: ENUM_DELIVERY_MODEL_LABELS[];
}

const DELIVERY_MODEL_INITIAL_STATE: DeliveryModelInitialState = {
  selectedsDeliveryModel: [ENUM_DELIVERY_MODEL_LABELS.ALL],
};

const deliveryModelSlice = createSlice({
  name: 'deliveries',
  initialState: DELIVERY_MODEL_INITIAL_STATE,
  reducers: {
    setSelectedsDeliveryModel(
      state,
      action: PayloadAction<ENUM_DELIVERY_MODEL_LABELS[]>,
    ) {
      state.selectedsDeliveryModel = action.payload;
    },
  },
});

export const { setSelectedsDeliveryModel } = deliveryModelSlice.actions;

export const deliveryModelReducer = deliveryModelSlice.reducer;
